import { getVersion, getName } from '@tauri-apps/api/app';
import { convertFileSrc } from '@tauri-apps/api/core';

// Check if we're running in a Tauri environment
export const isTauri = (): boolean => {
  // Check for Tauri-specific globals
  return typeof window !== 'undefined' && 
         '__TAURI_INTERNALS__' in window;
};

// Wrapper for Tauri-specific functionality
export const tauriWrapper = {
  invoke: async (command: string, args?: Record<string, unknown>): Promise<any> => {
    if (!isTauri()) {
      console.warn(`Tauri command '${command}' not available in web environment`);
      return Promise.resolve(null);
    }
    const { invoke } = await import('@tauri-apps/api/core');
    return invoke(command, args);
  },
  
  getCurrentWindow: async () => {
    if (!isTauri()) {
      return null;
    }
    const { WebviewWindow } = await import('@tauri-apps/api/webviewWindow');
    return WebviewWindow.getCurrent();
  },
  
  convertFileSrc: (src: string): string => {
    if (!isTauri()) {
      return src;
    }
    return convertFileSrc(src);
  },
  
  getAppInfo: async () => {
    if (!isTauri()) {
      return {
        name: 'Web App',
        version: '1.0.0'
      };
    }
    const name = await getName();
    const version = await getVersion();
    return { name, version };
  }
};